/*
 * Copyright (c) 2026 CalAmp Corp.  All Rights Reserved
 */
import {dlsDarkColor} from '../theme/theme';
import {useThemeMode} from '../theme/useThemeContext';

/**
 * Defines the useWordmarkFill hook which returns the fill of the CalAmp
 * wordmark: the `black` DLS color in dark mode, where the wordmark turns
 * light, otherwise the given light fill. The hook subscribes to the theme
 * mode, so a logo re-renders with the fill of the active mode when the mode
 * changes.
 *
 * ```typescript
 *   import {useWordmarkFill} from '@ion/dls/src/logo/useWordmarkFill';
 *   ...
 *
 *   const wordmarkFill = useWordmarkFill('#000');
 * ```
 *
 * @param lightFill The fill which is used in light mode, in legacy and in any
 *                  theme which has no dark mode.
 * @returns         The `black` DLS color in dark mode, otherwise `lightFill`.
 */
export const useWordmarkFill = (lightFill: string): string => {
  const {isDark} = useThemeMode();
  return dlsDarkColor(isDark, 'black', lightFill);
};
export default useWordmarkFill;
